import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { TourItem } from 'src/app/model/tour/tour-item';
import * as _ from 'lodash';

export class StonesErrorCalculationHelper {
  private constructor() {}

  static calculateStonesError(
    tourItems: TourItem[],
    maxStonesAllowed: number
  ): boolean {
    if (!CollectionHelper.isPopulated(tourItems)) {
      return false;
    }

    const counters: number[] = _.range(maxStonesAllowed + 1);
    const stonesErrorAtAnyPoint = counters.map(_ => false);

    for (const tourItem of tourItems) {
      if (
        tourItem.subProject == null ||
        !tourItem.subProject.onStones ||
        (tourItem.subProject.type !== 'BaseProject' &&
          tourItem.subProject.type !== 'Repo')
      ) {
        continue;
      }

      const signum = tourItem.subProject.type === 'BaseProject' ? -1 : 1;
      const baseAddend = tourItem.subProject.hasSecondBoard ? 2 : 1;

      for (let i = 0; i < counters.length; i++) {
        counters[i] += signum * baseAddend;
        stonesErrorAtAnyPoint[i] =
          stonesErrorAtAnyPoint[i] ||
          counters[i] < 0 ||
          counters[i] > maxStonesAllowed;
      }

      if (stonesErrorAtAnyPoint.every(b => b)) {
        return true;
      }
    }

    return stonesErrorAtAnyPoint.every(b => b);
  }
}
